<!--
  LTAP MFH FIELDS COMPONENT
  =========================
  Dedicated MFH input fields for LML Profile (LTAP) - Tanks assessment.
  Component type dropdown for selecting tank type (API 650 AST, more options to come).
-->
<fieldset class="border rounded-3 p-3">
    <legend class="subtitle-4 float-none w-auto px-3">
        Hydrostatic Pressure only, supplemental loads (e.g., wind and seismic) are not considered
    </legend>

    <div *ngIf="validationList.length > 0">
        <validation [ValidationList]="validationList" [ValidationLabel]="validationListLabel"></validation>
        <br />
    </div>

    <div class="container">
        <form [formGroup]="mfhForm">
            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <!-- FIELD 0: Component Type (Dropdown)                                          -->
            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <div class="form-group row align-items-center">
                <div class="col-sm-8 align-self-center">
                    <label for="ltap_selectedComponentType">Component type:</label>
                </div>
                <div class="col-sm-4">
                    <select
                        id="ltap_selectedComponentType"
                        formControlName="selectedComponentType"
                        class="form-control form-control-sm"
                        name="ltap_selectedComponentType"
                        (change)="onComponentTypeChange($event.target.value)"
                    >
                        <option value="" disabled selected hidden>Select Type</option>
                        <option *ngFor="let data of ComponentTypeData" [value]="data.value">
                            {{ data.text }}
                        </option>
                    </select>
                </div>
            </div>

            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <!-- FIELD 1: Inside Diameter, D                                                 -->
            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <div class="form-group row align-items-center">
                <div class="col-sm-8 align-self-center">
                    <label for="ltap_insideDiameter_MFH">Original inside diameter, D&nbsp;
                        <span *ngIf="intUnit === 0">(ft)</span>
                        <span *ngIf="intUnit === 1">(m)</span>:
                    </label>
                </div>
                <div class="col-sm-4">
                    <input
                        type="number"
                        labelDisable
                        appRestrictInput
                        id="ltap_insideDiameter_MFH"
                        formControlName="insideDiameter_MFH"
                        name="ltap_insideDiameter_MFH"
                        class="form-control form-control-sm"
                        (change)="onInsideDiameterChanged($event.target.value)"
                        min="0"
                    />
                </div>
            </div>

            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <!-- FIELD 2: Nominal Thickness, tnom                                            -->
            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <div class="form-group row align-items-center">
                <div class="col-sm-8 align-self-center">
                    <label for="ltap_nominalThickness_MFH">Original nominal thickness, tnom&nbsp;
                        <span *ngIf="intUnit === 0">(inch)</span>
                        <span *ngIf="intUnit === 1">(mm)</span>:
                    </label>
                </div>
                <div class="col-sm-4">
                    <input
                        type="number"
                        labelDisable
                        appRestrictInput
                        id="ltap_nominalThickness_MFH"
                        formControlName="nominalThickness_MFH"
                        name="ltap_nominalThickness_MFH"
                        class="form-control form-control-sm"
                        (change)="onNominalThicknessChanged($event.target.value)"
                        min="0"
                    />
                </div>
            </div>

            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <!-- FIELD 3: Internal Loss, LOSSi                                               -->
            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <div class="form-group row align-items-center">
                <div class="col-sm-8 align-self-center">
                    <label for="ltap_internalLoss_MFH">Current uniform metal loss (internal), LOSSi&nbsp;
                        <span *ngIf="intUnit === 0">(inch)</span>
                        <span *ngIf="intUnit === 1">(mm)</span>:
                    </label>
                </div>
                <div class="col-sm-4">
                    <input
                        type="number"
                        labelDisable
                        appRestrictInput
                        id="ltap_internalLoss_MFH"
                        formControlName="internalLoss_MFH"
                        name="ltap_internalLoss_MFH"
                        class="form-control form-control-sm"
                        (change)="onInternalLossChanged($event.target.value)"
                        min="0"
                    />
                </div>
            </div>

            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <!-- FIELD 4: External Loss, LOSSe                                               -->
            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <div class="form-group row align-items-center">
                <div class="col-sm-8 align-self-center">
                    <label for="ltap_externalLoss_MFH">Current uniform metal loss (external), LOSSe&nbsp;
                        <span *ngIf="intUnit === 0">(inch)</span>
                        <span *ngIf="intUnit === 1">(mm)</span>:
                    </label>
                </div>
                <div class="col-sm-4">
                    <input
                        type="number"
                        labelDisable
                        appRestrictInput
                        id="ltap_externalLoss_MFH"
                        formControlName="externalLoss_MFH"
                        name="ltap_externalLoss_MFH"
                        class="form-control form-control-sm"
                        (change)="onExternalLossChanged($event.target.value)"
                        min="0"
                    />
                </div>
            </div>

            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <!-- FIELD 5: Internal FCA, FCAi                                                 -->
            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <div class="form-group row align-items-center">
                <div class="col-sm-8 align-self-center">
                    <label for="ltap_internalFca_MFH">Future corrosion allowance (internal), FCAi&nbsp;
                        <span *ngIf="intUnit === 0">(inch)</span>
                        <span *ngIf="intUnit === 1">(mm)</span>:
                    </label>
                </div>
                <div class="col-sm-4">
                    <input
                        type="number"
                        labelDisable
                        appRestrictInput
                        id="ltap_internalFca_MFH"
                        formControlName="internalFca_MFH"
                        name="ltap_internalFca_MFH"
                        class="form-control form-control-sm"
                        (change)="onInternalFcaChanged($event.target.value)"
                        min="0"
                    />
                </div>
            </div>

            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <!-- FIELD 6: External FCA, FCAe                                                 -->
            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <div class="form-group row align-items-center">
                <div class="col-sm-8 align-self-center">
                    <label for="ltap_externalFca_MFH">Future corrosion allowance (external), FCAe&nbsp;
                        <span *ngIf="intUnit === 0">(inch)</span>
                        <span *ngIf="intUnit === 1">(mm)</span>:
                    </label>
                </div>
                <div class="col-sm-4">
                    <input
                        type="number"
                        labelDisable
                        appRestrictInput
                        id="ltap_externalFca_MFH"
                        formControlName="externalFca_MFH"
                        name="ltap_externalFca_MFH"
                        class="form-control form-control-sm"
                        (change)="onExternalFcaChanged($event.target.value)"
                        min="0"
                    />
                </div>
            </div>

            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <!-- FIELD 7: Allowable Stress, S                                                -->
            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <div class="form-group row align-items-center">
                <div class="col-sm-8 align-self-center">
                    <label for="ltap_allowableStress_MFH">
                        Allowable stress for the shell course under assessment according to API 653, S&nbsp;
                        <span *ngIf="intUnit === 0">(psi)</span>
                        <span *ngIf="intUnit === 1">(MPa)</span>:
                    </label>
                </div>
                <div class="col-sm-4">
                    <input
                        type="number"
                        labelDisable
                        appRestrictInput
                        id="ltap_allowableStress_MFH"
                        formControlName="allowableStress_MFH"
                        name="ltap_allowableStress_MFH"
                        class="form-control form-control-sm"
                        (change)="onAllowableStressChanged($event.target.value)"
                        min="0"
                    />
                </div>
            </div>

            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <!-- FIELD 8: Weld Joint Efficiency, E                                           -->
            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <div class="form-group row align-items-center">
                <div class="col-sm-8 align-self-center">
                    <label for="ltap_circumferentialWeldJointEfficiency_MFH">Weld joint efficiency, E</label>
                </div>
                <div class="col-sm-4">
                    <input
                        type="number"
                        labelDisable
                        appRestrictInput
                        id="ltap_circumferentialWeldJointEfficiency_MFH"
                        formControlName="circumferentialWeldJointEfficiency_MFH"
                        name="ltap_circumferentialWeldJointEfficiency_MFH"
                        class="form-control form-control-sm"
                        (change)="onCircumferentialWeldJointEfficiencyChanged($event.target.value)"
                        min="0"
                    />
                </div>
            </div>

            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <!-- FIELD 9: Design Liquid Head, H_L                                            -->
            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <div class="form-group row align-items-center">
                <div class="col-sm-8 align-self-center">
                    <label for="ltap_designLiquidHead_MFH">Tank maximum design filling height, H_L&nbsp;
                        <span *ngIf="intUnit === 0">(ft)</span>
                        <span *ngIf="intUnit === 1">(m)</span>:
                    </label>
                </div>
                <div class="col-sm-4">
                    <input
                        type="number"
                        labelDisable
                        appRestrictInput
                        id="ltap_designLiquidHead_MFH"
                        formControlName="designLiquidHead_MFH"
                        name="ltap_designLiquidHead_MFH"
                        class="form-control form-control-sm"
                        (change)="onDesignLiquidHeadChanged($event.target.value)"
                        min="0"
                    />
                </div>
            </div>

            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <!-- FIELD 10: Specific Gravity, s_g                                             -->
            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <div class="form-group row align-items-center">
                <div class="col-sm-8 align-self-center">
                    <label for="ltap_specificGravity_MFH">Specific gravity, s_g:</label>
                </div>
                <div class="col-sm-4">
                    <input
                        type="number"
                        labelDisable
                        appRestrictInput
                        id="ltap_specificGravity_MFH"
                        formControlName="specificGravity_MFH"
                        name="ltap_specificGravity_MFH"
                        class="form-control form-control-sm"
                        (change)="onSpecificGravityChanged($event.target.value)"
                        min="0"
                    />
                </div>
            </div>

            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <!-- FIELD 11: Shell Course Bottom Height, H_c                                   -->
            <!-- ═══════════════════════════════════════════════════════════════════════════ -->
            <div class="form-group row align-items-center">
                <div class="col-sm-8 align-self-center">
                    <label for="ltap_shellCourseBottomHeight_MFH">
                        Distance from the lower edge of the shell course under assessment to the tank floor, H_c&nbsp;
                        <span *ngIf="intUnit === 0">(ft)</span>
                        <span *ngIf="intUnit === 1">(m)</span>:
                    </label>
                </div>
                <div class="col-sm-4">
                    <input
                        type="number"
                        labelDisable
                        appRestrictInput
                        id="ltap_shellCourseBottomHeight_MFH"
                        formControlName="shellCourseBottomHeight_MFH"
                        name="ltap_shellCourseBottomHeight_MFH"
                        class="form-control form-control-sm"
                        (change)="onShellCourseBottomHeightChanged($event.target.value)"
                        min="0"
                    />
                </div>
            </div>
        </form>
    </div>
</fieldset>
